<template>
  <div class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Eliminar Administrador</h5>
          <button type="button" class="btn-close" @click="$emit('close')"></button>
        </div>
        
        <div class="modal-body">
          <div class="text-center">
            <i class="fas fa-exclamation-triangle text-warning mb-3" style="font-size: 3rem;"></i>
            <h5>¿Estás seguro?</h5>
            <p class="text-muted">
              Esta acción eliminará permanentemente al administrador:
            </p>
            <div class="alert alert-light">
              <strong>{{ user.firstname }} {{ user.lastname }}</strong><br>
              <small class="text-muted">{{ user.email }}</small>
            </div>
            <p class="text-danger">
              <small>Esta acción no se puede deshacer.</small>
            </p>
          </div>
        </div>
        
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="$emit('close')">
            Cancelar
          </button>
          <button 
            type="button" 
            class="btn btn-danger" 
            @click="confirmDelete"
            :disabled="isDeleting"
          >
            {{ isDeleting ? 'Eliminando...' : 'Sí, eliminar' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalDeleteUser',
  
  props: {
    user: { type: Object, required: true },
    token: { type: String, required: true }
  },
  
  emits: ['user-deleted', 'close'],
  
  data() {
    return {
      isDeleting: false
    };
  },
  
  methods: {
    async confirmDelete() {
      // Show SweetAlert confirmation
      const result = await this.$swal.fire({
        title: '¿Estás completamente seguro?',
        text: `Se eliminará permanentemente a ${this.user.firstname} ${this.user.lastname}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
      });
      
      if (result.isConfirmed) {
        await this.deleteUser();
      }
    },
    
    async deleteUser() {
      this.isDeleting = true;
      
      try {
        await axios.delete(`/api/users/${this.user.id}`, {
          headers: {
            'Authorization': `Bearer ${this.token}`
          }
        });
        
        this.$emit('user-deleted', this.user);
        
        this.$swal.fire({
          title: 'Eliminado!',
          text: 'El administrador ha sido eliminado correctamente.',
          icon: 'success',
          timer: 2000,
          showConfirmButton: false
        });
        
        this.$emit('close');
        
      } catch (error) {
        console.error('Error deleting user:', error);
        
        this.$swal.fire({
          title: 'Error!',
          text: error.response?.data?.message || 'Hubo un error al eliminar el administrador.',
          icon: 'error'
        });
      } finally {
        this.isDeleting = false;
      }
    }
  }
}
</script>

<style scoped>
.alert {
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
}

.text-warning {
  color: #ffc107 !important;
}

.text-danger {
  color: #dc3545 !important;
}

.text-muted {
  color: #6c757d !important;
}
</style>